import type { PageData } from '../types';
import { z } from 'zod';
import { LOCALES } from '../constants';

const metadata = z.object({
  description: z.string(),
  image: z.string(),
  open_graph: z.object({
    title: z.string(),
    description: z.string(),
    image: z.string(),
  }),
  twitter: z.object({
    title: z.string(),
    description: z.string(),
    image: z.string(),
  }),
  keywords: z.string(),
});

export const pageSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Title is required').max(100),
  claim_section_id: z.number().positive().nullable(),
  phone_id: z.number().int().positive().nullable().optional(),
  form_id: z.number().int().positive().nullable().optional(),
  slug: z
    .string()
    .min(1)
    .max(100)
    .regex(/^[a-z0-9\/-]+$/, {
      message: 'The path must only contain lowercase letters, numbers, hyphens, and slashes.',
    })
    .refine((s) => s.toLowerCase() === s, {
      message: 'The path must be entirely in lowercase.',
    })
    .refine((s) => !s.includes('//'), {
      message: 'The path cannot contain double slashes.',
    })
    .refine((s) => s.startsWith('/'), {
      message: "The path must start with a slash '/'.",
    }),
  content: z.custom<PageData<Record<string, unknown>>>(),
  draft_content: z.custom<PageData<Record<string, unknown>>>().optional().nullable(),
  metadata: metadata,
  draft_metadata: metadata.optional().nullable(),

  locale: z
    .string()
    .refine((locale) => LOCALES.includes(locale), { message: 'Invalid locale' })
    .transform((value) => Intl.getCanonicalLocales(value)[0]),
});

export type PageInput = z.infer<typeof pageSchema>;
